import { createSlice } from '@reduxjs/toolkit';
import store from './store';

const excludedPendingActions = [
  'weightTracker/deleteWeightEntry/pending',
  'recipes/toggleFavoriteMeal/fulfilled',
  'recipes/toggleFavoriteMeal/pending',
  'mealPlan/updateIngredientQuantity/pending',
  'mealPlan/fetchMealItemDetail/pending',
  'mealPlan/deleteMeal/pending'
];

const excludedFulfilledRejectedActions = [
  'weightTracker/deleteWeightEntry/fulfilled',
  'recipes/toggleFavoriteMeal/fulfilled',
  'recipes/toggleFavoriteMeal/pending',
  'mealPlan/updateIngredientQuantity/fulfilled',
  'mealPlan/fetchMealItemDetail/pending',
  'mealPlan/deleteMeal/fulfilled'
];

const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    isLoading: false,
  },
  reducers: {
    setLoadingTrue(state) {
      state.isLoading = true;
    },
    setLoadingFalse(state) {
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) =>
          action.type.endsWith('/pending') &&
          !excludedPendingActions.includes(action.type),
        (state) => {
          state.isLoading = true;
        }
      )
      .addMatcher(
        (action) =>
          (action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected')) &&
          !excludedFulfilledRejectedActions.includes(action.type),
        (state) => {
          state.isLoading = false;
        }
      );
  },
});

export const { setLoadingTrue, setLoadingFalse } = loadingSlice.actions;
export const selectIsLoading = (state) => state.loading.isLoading;
export default loadingSlice.reducer;

// Global utility functions
export const showLoader = () => {
  store.dispatch(setLoadingTrue());
};

export const hideLoader = () => {
  store.dispatch(setLoadingFalse());
};